import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import {
  fetchSystemsFailure,
  fetchSystemsStart,
  fetchSystemsSuccess,
  fetchSystemsSummaryFailure,
  fetchSystemsSummaryStart,
  fetchSystemsSummarySuccess
} from '../../store/slices/aiSystemsSlice';
import {
  fetchAISystems,
  getAiSystemsSummary
} from '../../services/AISystemsService';

export function useAiSystemOverview() {
  const dispatch = useAppDispatch();
  const { filters, pagination } = useAppSelector((state) => state.aiSystems);

  const fetchSystemsSummary = async () => {
    dispatch(fetchSystemsSummaryStart());
    try {
      const response = await getAiSystemsSummary();
      dispatch(fetchSystemsSummarySuccess(response));
    } catch (error) {
      if (error instanceof Error) {
        dispatch(fetchSystemsSummaryFailure(error.message));
      }
    }
  };

  // The server scopes the list from the token: a superadmin gets every tenant's
  // systems, an admin their whole organization, a user only what they are
  // assigned to. Passing ownerId to narrow it is neither needed nor correct —
  // it selected systems a user *owns*, so a system they hold as EDITOR was
  // invisible to them.
  const fetchSystems = async (useFilters = true) => {
    dispatch(fetchSystemsStart());
    try {
      const response = useFilters
        ? await fetchAISystems({
            search: filters.search,
            entity: filters.entity,
            riskClassification: filters.riskClassification,
            complianceStatus: filters.complianceStatus,
            ownerId: filters.owners,
            organization: filters.organization,
            accountId: filters.accountId,
            offset: pagination.offset,
            limit: pagination.limit
          })
        : await fetchAISystems();

      dispatch(fetchSystemsSuccess(response));
    } catch (error: any) {
      dispatch(fetchSystemsFailure(error.message));
    }
  };

  return {
    fetchSystemsSummary,
    fetchSystems
  };
}
